<header
  class="shell-header z-30 h-14 md:h-[3.5rem] px-3 md:px-5 flex items-center justify-between
         rounded-full
         bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl
         text-slate-700 dark:text-slate-200
         border border-white/70 dark:border-slate-700/60
         shadow-[0_8px_28px_-14px_rgba(15,23,42,0.28)] dark:shadow-[0_8px_28px_-10px_rgba(0,0,0,0.55)]
         transition-colors duration-300"
  *ngIf="!disableHeader">

  <!-- ─── Left: Hamburger (mobile) & Lock Toggle (desktop) ─── -->
  <div class="flex items-center gap-1.5">
    <button (click)="toggleSidebar.emit()"
      class="xl:hidden w-9 h-9 rounded-full transition cursor-pointer flex items-center justify-center
             hover:bg-amber-50 dark:hover:bg-slate-800 active:scale-95 text-slate-500 dark:text-slate-400">
      <span class="material-icons text-xl">menu</span>
    </button>

    <button (click)="toggleSidebarLock()"
      class="hidden xl:flex w-9 h-9 rounded-full transition cursor-pointer items-center justify-center
             hover:bg-amber-50 dark:hover:bg-slate-800 active:scale-95 text-slate-400 dark:text-slate-500
             hover:text-amber-500">
      <span class="material-icons text-xl">notes</span>
    </button>
  </div>

  <!-- ─── Right: Search / Theme / Profile ─── -->
  <div class="flex items-center gap-1.5 md:gap-2">

    <!-- Search (Ctrl + K) -->
    <button type="button" (click)="openMenuPalette()" title="ค้นหาเมนู (Ctrl K)"
      class="h-9 rounded-full transition cursor-pointer flex items-center gap-2 px-2 md:pl-3 md:pr-2
             hover:bg-amber-50 dark:hover:bg-slate-800 active:scale-95 text-slate-400 dark:text-slate-500
             md:bg-slate-100/70 md:dark:bg-slate-800/80 md:border md:border-slate-200/70 md:dark:border-slate-700/60">
      <span class="material-icons text-xl">search</span>
      <span class="hidden md:inline text-sm text-slate-400 pr-6">ค้นหาเมนู...</span>
      <kbd class="hidden md:inline text-[10px] text-slate-400 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-1 font-sans">Ctrl K</kbd>
    </button>

    <button (click)="toggleTheme()"
      class="theme-btn w-9 h-9 rounded-full transition cursor-pointer flex items-center justify-center
             hover:bg-amber-50 dark:hover:bg-slate-800 active:scale-95 text-slate-400 dark:text-slate-500
             hover:text-amber-500">
      <span class="material-icons-outlined text-xl">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</span>
    </button>

    <button
      class="w-9 h-9 rounded-full transition cursor-pointer flex items-center justify-center
             hover:bg-amber-50 dark:hover:bg-slate-800 active:scale-95 text-slate-400 dark:text-slate-500 relative">
      <span class="material-icons text-xl">notifications_none</span>
      <span class="absolute top-2 right-2 w-1.5 h-1.5 rounded-full bg-amber-400 ring-2 ring-white dark:ring-slate-900"></span>
    </button>

    <div class="relative pl-1">
      <button (click)="toggleDropdown()"
        class="flex items-center gap-2 pl-1.5 pr-2.5 py-1 rounded-full transition
               hover:bg-amber-50/80 dark:hover:bg-slate-800 active:scale-95
               border border-transparent hover:border-amber-200/50 dark:hover:border-slate-700">
        <img src="img/user.png" alt="profile"
          class="h-8 w-8 rounded-full border-2 border-amber-300/70 dark:border-amber-500/40
                 shadow-sm shadow-amber-200/40" />
        <div class="hidden md:flex flex-col items-start leading-tight min-w-0">
          <span class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate max-w-[120px]">{{ name }}</span>
          <span *ngIf="role" class="text-[10px] font-semibold text-slate-400 dark:text-slate-500 truncate max-w-[120px]">{{ role }}</span>
        </div>
        <span class="material-icons text-sm hidden md:block text-slate-400 transition-transform duration-200"
          [class.rotate-180]="showDropdown">expand_more</span>
      </button>

      <div *ngIf="showDropdown"
        class="absolute right-0 mt-2.5 w-56 rounded-2xl shadow-2xl overflow-hidden z-50 animate-fade-in-up
               bg-white/95 dark:bg-slate-900/95 border border-slate-100 dark:border-slate-800 backdrop-blur-md">
        <div
          class="px-4 border-b space-y-1 py-2 border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/50">
          <p class="text-xs text-slate-400 dark:text-slate-500 font-bold uppercase tracking-wider">บัญชีผู้ใช้</p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-200 truncate mt-0.5">{{ name }}</p>
          <p class="text-[11px] text-slate-400 dark:text-slate-500 truncate">{{ role }}</p>
        </div>

        <div class="p-1">
          <button type="button" (click)="openProfileModal()"
            class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm transition font-bold rounded-xl
                   text-slate-600 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-800">
            <span class="material-icons text-[18px] text-amber-500">manage_accounts</span>
            แก้ไขข้อมูลส่วนตัว
          </button>
          <button type="button" (click)="openLogoutModal()"
            class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm transition font-bold rounded-xl
                   text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/20">
            <span class="material-icons text-[18px]">logout</span>
            ออกจากระบบ
          </button>
        </div>
      </div>
    </div>
  </div>

</header>

<app-pss-confirm-modal *ngIf="isLogoutModalOpen" title="ยืนยันการออกจากระบบ?" message="คุณต้องการออกจากระบบ"
  messageSuffix="หรือไม่?" confirmLabel="ออกจากระบบ" variant="warning" icon="logout" [showIrreversibleNote]="false"
  (confirm)="confirmLogout()" (cancel)="closeLogoutModal()">
</app-pss-confirm-modal>

<app-modal-my-profile *ngIf="isProfileModalOpen"
  (close)="closeProfileModal()"
  (saved)="onProfileSaved($event)">
</app-modal-my-profile>
